import dayjs from 'dayjs';

const formatDate = (date: Date) => {
  return dayjs(date).format('YYYY-MM-DD')
}

export { formatDate }
